import { OrganizationReportDecryptionChartEntity } from '../entities/';
import { authResource } from './Auth';
export const OrganizationReportDecryptionChartResource = authResource({
    path: '/organizations/:organizationId/reports/decryptions/chart/:chartId?',
    schema: OrganizationReportDecryptionChartEntity,
    searchParams: {}
});
